import { createStoreCreator } from 'lib/store'
import reducer from 'reports/hourlyScrap/reducers'

export default createStoreCreator(reducer)
